import { FmIcon } from "@/ui-component";

interface ISelectedTagProps {
    value: string;
    onClick: () => void;
}
export function SelectedTag({ value, onClick }: ISelectedTagProps) {
    return (
        <span
            style={{
                display: "flex",
                background: "#EEF0F0",
                padding: "0.1rem",
                marginRight: "0.1rem",
                marginTop: "0.1rem",
            }}
        >
            {value}
            <FmIcon
                style={{ marginLeft: "0.05rem", fontSize:'x-large' }}
                onClick={(e) => {
                    e.preventDefault();
                    onClick();
                }}
                icon="icon--close"
            ></FmIcon>
        </span>
    );
}
